function contactShowDirective() {
	return {
		scope : {
			idClient : '=',
			idSite : '=?',
			idContact : '='
		},
		restrict : 'E',
		replace : true,
		templateUrl : function(elem, attr) {
			return 'views/directives/contactShowDirective.html';
		},
		controller : [
				'$scope',
				'$window',
				'alertService',
				'clientService',
				'securityService',
				function($scope, $window, alertService, clientService,
						securityService) {
					$scope.contact = null;

					$scope.loadContact = function(idClient, idSite, idContact) {

						if (!idClient) {
							return;
						}

						if (idSite) {

							clientService.getClientSiteContact(idClient,
									idSite).then(function(response) {
								$scope.contact = response.getData();
							}, function(response) {
								// on error
							});

						} else {
							if (!idContact) {
								return;
							}

							clientService.getClientContact(idClient,
									idContact).then(function(response) {
								$scope.contact = response.getData();
							}, function(response) {
								// on error
							});

						}
					};

					$scope.loadContact($scope.idClient, $scope.idSite,
							$scope.idContact);

				} ],
		link : function(scope, elem, attr) {
			scope.$watch('idSite', function(newValue, oldValue) {
				scope
						.loadContact(scope.idClient, scope.idSite,
								scope.idContact);
			}, true);
			scope.$watch('idClient', function(newValue, oldValue) {
				scope
						.loadContact(scope.idClient, scope.idSite,
								scope.idContact);
			}, true);
		}
	};
};

module.directive('contactShow', [ contactShowDirective ]);